import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BrandLogo from '@/components/UI/BrandLogo';

const NO_HEADER_PATHS = ['/login', '/register', '/verify-email', '/forgot-password', '/reset-password', '/onboarding/plans', '/onboarding/setup', '/onboarding/profile'];

const BaseLayout: React.FC = () => {
  const { pathname } = useLocation();
  const hideHeader =
    NO_HEADER_PATHS.includes(pathname) || pathname.startsWith('/invite/');

  return (
    <div className={hideHeader ? '' : 'min-h-svh bg-ui'}>
      {!hideHeader && (
        <header className="flex h-14 items-center border-b border-ui-border bg-ui-card px-4 md:px-6">
          <BrandLogo surface="auto" height={28} />
        </header>
      )}
      <main className={hideHeader ? '' : 'pt-4'}>
        <Outlet />
      </main>
    </div>
  );
};

export default BaseLayout;
